export default __webpack_public_path__ + "static/media/flag-guyana.d72fa6b1.svg";